/**
 * 资源查询服务实现类
 */
const IResourceQueryService = require('../IResourceQueryService');
const SqlParserUtil = require('./common/SqlParserUtil');
const Util = require('./common/Util');
const Extend = require('../../../base/util/Extend');
/**
 * @classdesc 资源查询服务
 * @alias G.servicev2.ResourceQueryServiceImpl
 * @augments G.service.IResourceQueryService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class ResourceQueryServiceImpl extends IResourceQueryService {
    constructor(opts) {
        super(opts);
    }

    /**
     * @inheritdoc
     */
    getPageList(opts) {
        return new Promise(async(resolve, reject) => {
            let options = Extend(true, {}, opts);
            options.pageNo = options.pageNo || 1;
            options.pageSize = options.pageSize || 10;
            let tables = [options];
            let useAggregate = this._useAggregate(tables);
            if (useAggregate) {
                let aggregateCol = await this._parseAggregateCol(tables);
                let data = await Util.aggregateMulti({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    aggregateList: aggregateCol,
                    dataParser: (result) => {
                        return this._dataParser(result, tables);
                    }
                });
                let result = data[0];
                result.pageSize = options.pageSize;
                result.pageNo = options.pageNo;
                let queryCol = await this._parseQueryCol([options]);
                let queryObj = queryCol[options.table];
                queryObj.select = '_id';
                queryObj.limit = 1;
                queryObj.page = 1;
                delete queryObj.populate;
                result.total = await Util.query({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    table: options.table,
                    data: queryObj,
                    dataParser: function(data) {
                        return data.total;
                    }
                });
                resolve(result);
            } else {
                let queryCol = await this._parseQueryCol(tables);
                let queryObj = queryCol[options.table];
                let data = await Util.query({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    table: opts.table,
                    data: queryObj,
                    dataParser: function(data) {
                        return data;
                    }
                });
                resolve(data);
            }
        });
    }

    /**
     * @inheritdoc
     */
    getList(opts) {
        return new Promise(async(resolve, reject) => {
            let tables = [opts];
            let useAggregate = this._useAggregate(tables);
            if (useAggregate) {
                let aggregateCol = await this._parseAggregateCol(tables);
                let data = await Util.aggregateMulti({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    aggregateList: aggregateCol,
                    dataParser: (result) => {
                        return this._dataParser(result, tables);
                    }
                });
                resolve(data[0]);
            } else {
                let queryCol = await this._parseQueryCol(tables);
                let data = await Util.queryMulti({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    data: queryCol,
                    dataParser: function(data) {
                        return data;
                    }
                });
                let result = {};
                result.list = data[opts.table];
                result.table = opts.table;
                resolve(result);
            }
        });
    }

    //
    _dataParser(result, tables) {
        let resultCol = [];
        for (let i = 0; i < tables.length; i++) {
            let tableObj = tables[i];
            let resultObj = {};
            let list = result[i][tableObj.table];
            resultObj.list = list;
            resultObj.table = tableObj.table;
            resultCol.push(resultObj);
            //
            let relationSet = {};
            for (let j = 0; j < tableObj.relation.length; j++) {
                relationSet[tableObj.relation[j].alias] = tableObj.relation[j];
            }
            //
            for (let j = 0, len = list.length; j < len; j++) {
                let item = list[j];
                for (let k in item.tag) {
                    item[k] = item.tag[k];
                }
                item.id = item._id;
                delete item._id;
                delete item.tag;
                for (let relKey in relationSet) {
                    let relationData = item[relKey];
                    if (relationSet[relKey].type == 'many') {
                        for (let m = 0, len1 = relationData.length; m < len1; m++) {
                            relationData[m] = relationData[m].tag;
                        }
                    } else {
                        item[relKey] = relationData.tag;
                    }
                }
            }
        }
        return resultCol;
    }

    /**
     * @inheritdoc
     */
    getListBatch(opts) {
        return new Promise(async(resolve, reject) => {
            let tables = opts.tables;
            let useAggregate = this._useAggregate(tables);
            if (useAggregate) {
                let aggregateCol = await this._parseAggregateCol(tables);
                let data = await Util.aggregateMulti({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    aggregateList: aggregateCol,
                    dataParser: (result) => {
                        return this._dataParser(result, tables);
                    }
                });
                resolve(data);
            } else {
                let queryCol = await this._parseQueryCol(tables);
                let data = await Util.queryMulti({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    data: queryCol,
                    dataParser: function(data) {
                        let list = [];
                        for (let i = 0; i < opts.tables.length; i++) {
                            list.push({
                                table: opts.tables[i].table,
                                list: data[opts.tables[i].table]
                            });
                        }
                        return list;
                    }
                });
                resolve(data);
            }
        });
    }

    //
    _useAggregate(tables) {
        let flag = false;
        for (let i = 0; i < tables.length; i++) {
            let tableObj = tables[i];
            if (tableObj && tableObj.relation && tableObj.relation.length > 0) {
                flag = true;
                break;
            }
        }
        return flag;
    }

    //拼接
    _parseQueryCol(tables) {
        return new Promise(async(resolve, reject) => {
            const paramMap = {
                'pageNo': 'page',
                'pageSize': 'limit'
            }
            let queryCol = {};
            let relateTables = {};
            for (let i = 0; i < tables.length; i++) {
                let tableObj = tables[i];
                if (tableObj.returnRelation) {
                    relateTables[tableObj.table] = i;
                }
                let queryObj = {};
                let queryAnd = [];
                queryCol[tableObj.table] = queryObj;
                //
                for (let k in paramMap) {
                    queryObj[paramMap[k]] = tableObj[k];
                }
                //select
                if (tableObj.select) {
                    let parsetResult = SqlParserUtil.parseSqlFragment('select', tableObj.select);
                    let select = SqlParserUtil.translateSelect(parsetResult);
                    queryObj.select = select;
                }
                // where 
                if (tableObj.where) {
                    let parseResult = SqlParserUtil.parseSqlFragment('where', tableObj.where);
                    let query = SqlParserUtil.translateWhere(parseResult);
                    queryAnd.push(query);
                }
                //geometry filter
                if (tableObj.geometry) {
                    let geometryFilter = SqlParserUtil.parseGeometryFilter({
                        geometry: tableObj.geometry,
                        inputSr: tableObj.inputSr || 4326,
                        dataSr: 4326,
                        spatialRel: tableObj.spatialRel || 'intersects',
                    });
                    queryAnd.push(geometryFilter);
                }
                // sort 
                if (tableObj.sort) {
                    let parseResult = SqlParserUtil.parseSqlFragment('sort', tableObj.sort);
                    let sort = SqlParserUtil.translateSort(parseResult);
                    queryObj.sort = sort;
                }
                if (queryAnd.length > 0) {
                    queryObj.query = {
                        '$and': queryAnd
                    }
                }
            }
            let relationTableNames = Object.keys(relateTables);
            if (relationTableNames.length > 0) {
                //元数据
                let metaCol = await Util.getMetas({
                    url: this.opts.url,
                    httpRequest: this.opts.httpRequest,
                    tables: relationTableNames
                });
                for (let i = 0; i < relationTableNames.length; i++) {
                    let queryObj = queryCol[relationTableNames[i]];
                    let metaObj = metaCol[i];
                    let populate = [];
                    let relFields = [];
                    //
                    for (let j = 0; j < metaObj.model.length; j++) {
                        let fieldObj = metaObj.model[j];
                        if (fieldObj && fieldObj.fieldRef) {
                            let fieldName = 'tag.' + fieldObj.fieldName;
                            populate.push([fieldName]);
                            relFields.push(fieldName);
                        }
                    }
                    if (populate.length > 0) {
                        queryObj.populate = populate;
                        if (queryObj.select) {
                            queryObj.select += ' ' + relFields.join(' ');
                        }
                    }
                }
            }
            resolve(queryCol);
        });
    }

    //拼接管道
    _parseAggregateCol(tables) {
        return new Promise(async(resolve, reject) => {
            let aggregateCol = [];
            for (let i = 0; i < tables.length; i++) {
                let tableObj = tables[i];
                let aggregateObj = {},
                    aggregate = [];
                aggregateObj.query = {};
                aggregateObj.searchId = i;
                aggregateObj.dataSetId = tableObj.table;
                aggregateObj.queryIndex = 0;
                let queryAnd = [];
                //query
                if (tableObj.where) {
                    let parseResult = SqlParserUtil.parseSqlFragment('where', tableObj.where);
                    let query = SqlParserUtil.translateWhere(parseResult);
                    queryAnd.push(query);
                }
                //geometry filter
                if (tableObj.geometry) {
                    let geometryFilter = SqlParserUtil.parseGeometryFilter({
                        geometry: tableObj.geometry,
                        inputSr: tableObj.inputSr || 4326,
                        dataSr: 4326,
                        spatialRel: tableObj.spatialRel || 'intersects',
                    });
                    queryAnd.push(geometryFilter);
                }
                if (queryAnd.length > 0) {
                    aggregateObj.query = {
                        '$and': queryAnd
                    }
                }
                //
                let relationSet = {};
                tableObj.relation = tableObj.relation || [];
                for (let j = 0; j < tableObj.relation.length; j++) {
                    let relationTable = tableObj.relation[j];
                    let lookup = {};
                    lookup.from = 'user_safety_' + relationTable.table;
                    lookup.localField = 'tag.' + relationTable.localField;
                    lookup.foreignField = 'tag.' + relationTable.foreignField;
                    lookup.as = relationTable.alias;
                    relationSet[lookup.as] = relationTable;
                    aggregate.push({
                        $lookup: lookup
                    });
                    if (relationTable.type != 'many') {
                        aggregate.push({
                            '$unwind': {
                                "path": "$" + relationTable.alias,
                                "preserveNullAndEmptyArrays": true
                            }
                        })
                    }
                }
                // sort 
                if (tableObj.sort) {
                    let sortParseResult = SqlParserUtil.parseSqlFragment('sort', tableObj.sort);
                    let sort = SqlParserUtil.translateSortAggregate(sortParseResult);
                    aggregate.push({
                        '$sort': sort
                    });
                }
                //page
                if (!isNaN(tableObj.pageNo)) {
                    let pageSize = tableObj.pageSize || 10;
                    aggregate.push({
                        "$skip": (tableObj.pageNo - 1) * pageSize
                    });
                    aggregate.push({
                        "$limit": pageSize
                    });
                }
                //
                let project = {};
                if (tableObj.select) {
                    let parsetResult = SqlParserUtil.parseSqlFragment('select', tableObj.select);
                    let select = SqlParserUtil.translateSelect(parsetResult);
                    let selectList = select.split(' ');
                    for (let m = 0; m < selectList.length; m++) {
                        project[selectList[m]] = '$' + selectList[m];
                    }
                } else {
                    project['tag'] = '$tag';
                }
                for (let key in relationSet) {
                    project[key] = '$' + key;
                }
                aggregate.push({
                    $project: project
                });
                aggregateObj.aggregate = aggregate;
                aggregateCol.push(aggregateObj);
            }
            resolve(aggregateCol);
        });
    }

}
module.exports = ResourceQueryServiceImpl;